import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/Header.css";
import MenuPortalItem from "./MenuPortalItem";
import { useAuth } from "../contexts/AuthContext";
import { CBTKD_ID } from "../constantes/EntidadesConstantes";
// import SecurityRulesService from "../services/SecurityRules.service";
// import "../styles/SideMenuPortals.css";

export default function BannerPortals(props) {
  const { currentUser, domainDetails } = useAuth();
  // ToDo: Quando acessa um portal, retirar este da lista e incluir o que estiver faltando.
  // Todo: Somente apresentar o portal de Gestão para os usuários que possuem permissão.
  const [showGestao, setShowGestao] = React.useState(false);
  // const [show_Helpdesk, setShow_Helpdesk] = React.useState(false);
  const portalNoticias = "1";
  const portalGestao = "2";
  const portalTransparencia = "3";
  const portalInstitucional = "4";
  const portalEducacional = "5";
  // const portalHelpdesk = "6";

  useEffect(() => {
    if (currentUser) {
      if (currentUser.rulesOwned) {
        if (currentUser.rulesOwned.length > 0) {
          // console.log("currentUser.rulesOwned:", currentUser.rulesOwned);
          if (
            currentUser.rulesOwned.filter(
              (rule) =>
                (rule >= 100 && rule <= 199) ||
                (rule >= 200 && rule <= 299) ||
                (rule >= 300 && rule <= 399) ||
                (rule >= 400 && rule <= 499) ||
                (rule >= 500 && rule <= 599) ||
                (rule >= 600 && rule <= 699) ||
                (rule >= 700 && rule <= 799) ||
                (rule >= 800 && rule <= 899)

              // rule !== 901 && rule !== 902 && rule !== 905 && rule !== 906 && rule !== 907 && rule !== 908 && rule !== 910 && rule !== 912
            ).length > 0
          ) {
            setShowGestao(props.portalid !== portalGestao);
          }
          // if (currentUser.rulesOwned.filter((rule) => rule >= 1701 && rule <= 1714).length > 0) {
          //   setShow_Helpdesk(props.portalid !== portalHelpdesk);
          //   //console.log(`show_Helpdesk: ${props.portalid !== portalHelpdesk}`);
          // }
        } else {
          setShowGestao(false);
          // setShow_Helpdesk(false);
        }
      }
    }
  }, [currentUser]);

  const showNoticias = () => {
    return domainDetails ? domainDetails.portalId !== portalNoticias : false;
  };
  const showTransparencia = () => {
    return domainDetails ? domainDetails.portalId !== portalTransparencia : false;
  };
  const showInstitucional = () => {
    return domainDetails ? domainDetails.portalId !== portalInstitucional : false;
  };
  const showEducacional = () => {
    return domainDetails ? (domainDetails.portalId !== portalEducacional && domainDetails.urlEducacional !== "") : false;
  };
  const showOuvidoria = () => {
    return domainDetails ? (domainDetails.portalId !== portalEducacional && domainDetails.urlOuvidoria !== "") : false;
    // return domainDetails ? domainDetails.portalId !== portalEducacional : false;
  };
  // const showHelpdesk = () => {
  //   //console.log(`show_Helpdesk: ${show_Helpdesk}`);
  //   //console.log("domainDetails.portalId !== portalHelpdesk:", domainDetails.portalId !== portalHelpdesk);
  //   //console.log("show_Helpdesk && domainDetails.portalId:", domainDetails.portalId);
  //   return domainDetails ? domainDetails.portalId !== portalHelpdesk && show_Helpdesk : false;
  // };
  useEffect(() => {
    if (!props.showFixed) {
      const scrollFunction = () => {
        if (document.body.scrollTop > 524 || document.documentElement.scrollTop > 524) {
          let stickyBannerPortais = document.getElementById("stickyBannerPortais");
          if (stickyBannerPortais) stickyBannerPortais.style.transform = "translateY(-25px) scale(0.62)";
          let stickyBannerPortaisFlex = document.getElementById("stickyBannerPortaisFlex");
          if (stickyBannerPortaisFlex) stickyBannerPortaisFlex.style.flexWrap = "nowrap";
          let stickyBannerPortaisBar = document.getElementById("stickyBannerPortaisBar");
          if (stickyBannerPortaisBar) {
            stickyBannerPortaisBar.style.height = "80px";
            stickyBannerPortaisBar.style.opacity = "1.0";
            stickyBannerPortaisBar.style.backgroundColor = "var(--bs-gray-100)";
            stickyBannerPortaisBar.style.boxShadow = "0px 0px 1px 0px rgba(0,0,0,0.75)";
          }
        } else {
          let stickyBannerPortais = document.getElementById("stickyBannerPortais");
          if (stickyBannerPortais) stickyBannerPortais.style.transform = "scale(1.0)";
          let stickyBannerPortaisFlex = document.getElementById("stickyBannerPortaisFlex");
          if (stickyBannerPortaisFlex) stickyBannerPortaisFlex.style.flexWrap = "wrap";
          let stickyBannerPortaisBar = document.getElementById("stickyBannerPortaisBar");
          if (stickyBannerPortaisBar) {
            stickyBannerPortaisBar.style.height = "auto";
            stickyBannerPortaisBar.style.opacity = "1.0";
            stickyBannerPortaisBar.style.backgroundColor = "var(--bs-gray-300)";
            stickyBannerPortaisBar.style.boxShadow = "none";
          }
        }
      };

      window.onscroll = function () {
        scrollFunction();
      };
    }
  }, []);

  if (!domainDetails) return <div></div>;
  else
    return (
      // <div id="my-modal-portals" className="modal transparent-background-color" tabIndex="-1" role="dialog" aria-hidden="true">
      //   <div className="modal-dialog modal-sm-portais shadow MenuPortalPosition" role="document">
      //     <div className="modal-content">
      //       <div className="modal-body containerMenuPortal">
      <div
        id="stickyBannerPortaisBar"
        className="w-100 align-items-center justify-content-center"
        style={
          props.showFixed
            ? {
              marginTop: "38px",
              paddingTop: "24px",
              paddingBottom: "24px",
              height: "80px",
              opacity: "1.0",
              backgroundColor: "var(--bs-gray-100)",
              boxShadow: "0px 0px 0px 1px rgba(0,0,0,0.12)",
              position: "fixed",
              top: "0",
            }
            : {
              marginTop: "36px",
              paddingTop: "24px",
              paddingBottom: "24px",
              backgroundColor: "var(--bs-gray-300)",
              backgroundPositionY: "36px",
            }
        }
      >
        <div
          id="stickyBannerPortais"
          className="container"
          style={
            props.showFixed
              ? {
                transform: "translateY(-25px) scale(0.62)",
              }
              : {
                transitionDuration: "70ms",
              }
          }
        >
          <div className="container-fluid">
            <div
              id="stickyBannerPortaisFlex"
              className="horizontalElements gap-4"
              style={
                props.showFixed
                  ? {
                    flexWrap: "nowrap",
                  }
                  : {
                    flexWrap: "wrap",
                  }
              }
            >
              {showNoticias() && (
                <MenuPortalItem
                  href="/"
                  src="/assets/images/noticias-symbol-preto.png"
                  caption="Notícias"
                  value="noticias"
                  reverseColors={true}
                  showFixed={props.showFixed ? true : false}
                />
              )}
              {showInstitucional() && (
                <MenuPortalItem
                  href="/institucional"
                  src="/assets/images/cbtkd-simbolo-preto.png"
                  caption="Institucional"
                  value="institucional"
                  reverseColors={true}
                />
              )}
              <MenuPortalItem
                href={domainDetails.urlYouTubeChannel}
                src="/assets/images/cbtkd-tv.png"
                caption={domainDetails.nameYouTubeChannel}
                reverseColors={true}
              />
              {showEducacional() && (
                <MenuPortalItem
                  // href="cbtkdeduca"
                  href={domainDetails.urlEducacional}
                  src="/assets/images/cbtkd-educa.png"
                  caption={domainDetails.nameEducacional}
                  value="cbtkdeduca"
                  reverseColors={true}
                />
              )}
              {/* </div>
              <div className="horizontalElements"> */}
              {showTransparencia() && (
                <MenuPortalItem
                  href="/transparencia"
                  src="/assets/images/cbtkd-transparencia.png"
                  caption="Transparência"
                  value="transparencia"
                  reverseColors={true}
                />
              )}
              {showOuvidoria() && (
                <MenuPortalItem
                  href={domainDetails.urlOuvidoria}
                  src="/assets/images/cbtkd-ouvidoria.png"
                  caption="Ouvidoria"
                  reverseColors={true}
                />
              )}
              {showGestao === true && (
                <MenuPortalItem href="/sie" src="/assets/images/cbtkd-gestao.png" caption="SIE" value="sie" reverseColors={true} />
              )}
              {/* {showHelpdesk() && (
                <MenuPortalItem
                  href="/helpdesk"
                  src="/assets/images/helpdesk.png"
                  caption="Central de Ajuda"
                  value="helpsdesk"
                  reverseColors={true}
                  hideOnMobile={true}
                />
              )} */}
            </div>
          </div>
        </div>
      </div>
      //       </div>
      //     </div>
      //   </div>
      // </div>
    );
}
